// seller-service property endpoint paths (relative to VITE_SELLER_API_URL). The
// service mounts under the `/api` global prefix. Referenced via this constant so
// a path change is a single edit — never hard-coded at call sites.
export const propertyEndpointPaths = {
  PROPERTIES: '/api/properties',
  PORTFOLIO_STATUS: '/api/properties/portfolio-status',
  property: (id: string) => `/api/properties/${id}`,
} as const
